import { _ } from "@/pages/_app";
import { useEffect, useState } from "react";
import ButtonNew from '@/components/buttons/ButtonNew';
import { setNotTrack } from "@/utils/analyticsFunctions";
import { set } from "date-fns";

const CookieBanner = () => {
  const [hide, setHide] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      const hasChoice = !!window.localStorage.getItem("allowed-cookies");
      setHide(hasChoice);

      // Prevent scrolling if banner is shown
      if (!hasChoice) {
        document.body.style.overflow = 'hidden';
      }
    }, 2000);
  }, []);

  useEffect(() => {
    // Re-enable scrolling when banner is hidden
    if (hide) {
      document.body.style.overflow = '';
    } else {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [hide]);

  const handleChoice = (allowed: boolean) => {
    setHide(true);
    if (!allowed) {
      setNotTrack();
      window.localStorage.setItem("allowed-cookies", "false");
    } else {
      window.localStorage.setItem("allowed-cookies", "true");
    }
    // Re-enable scrolling
    document.body.style.overflow = 'unset';
  };

  if (hide) {
    return null;
  }

  return (
    <div>
      <div
        className="fixed inset-0 bg-[#171008CC] z-[9998]"
        style={{ backdropFilter: 'blur(2px)' }}
      />

      <div className="fixed inset-0 flex items-center justify-center z-[9999] p-4">
        <div
          id="cookie-banner"
          className="flex flex-col items-center gap-[1rem] bg-[#F4EEE8] rounded-[1rem] px-[1.5rem] py-[1.5rem] md:px-[3.2rem] md:py-[3.2rem] w-[40rem]"
        >
          <div className="flex flex-col items-center gap-[0.8rem] md:gap-[1.2rem]">
            <h2 className="text-[#1b1817] text-[1.4rem] md:text-[2rem] text-center font-semibold leading-[1.6rem] md:leading-[2.2rem] font-poppins">
              {_("cookies-banner_heading")}
            </h2>
            <div className="flex flex-col items-center gap-[0.8rem] md:gap-[1rem]">
              <p className="text-center text-[0.9rem] md:text-[1rem]">
                {_("cookies-banner_description")}
              </p>
              <div>
                <p className="text-center text-[0.9rem] md:text-[1rem]">
                  {_("cookies-banner_terms")}{' '}
                  <a
                    className="inline underline"
                    href="https://www.horseday.com/terms-privacy"
                  >
                    {_("cookies-banner_terms-link")}
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          <div className="mt-4 flex flex-row justify-center items-center gap-[0.5rem] sm:gap-[unset]">
            <ButtonNew
              variant="text"
              onClick={() => {
                setHide(true);
                setNotTrack();
                window.localStorage.setItem("allowed-cookies", "false");
                document.body.style.overflow = 'unset';
              }}
            >
              {_("cookie-banner__decline-btn")}
            </ButtonNew>
            <ButtonNew
              variant="primary"
              onClick={() => {
                setHide(true);
                window.localStorage.setItem("allowed-cookies", "true");
                document.body.style.overflow = 'unset';
              }}
            >
              {_("cookie-banner__ok-btn")}
            </ButtonNew>
          </div>
        </div>
      </div>
    </div >
  );
};

export default CookieBanner;
